import { t } from "@lingui/macro";
import type { TemplateId } from "../../convex/templateTypes";

export type TemplateCatalogEntry = {
  id: TemplateId;
  label: string;
  screenshot: string;
};

export const TEMPLATE_CATALOG: Array<TemplateCatalogEntry> = [
  {
    id: "narrative",
    label: t`Narrativo / Escénico`,
    screenshot: "/template-narrative-desktop.webp",
  },
  {
    id: "watercolor",
    label: t`Acuarela / Pastel`,
    screenshot: "/template-watercolor-desktop.webp",
  },
  {
    id: "typographic",
    label: t`Tipográfico / Moderno`,
    screenshot: "/template-typographic-desktop.webp",
  },
  {
    id: "editorial",
    label: t`Editorial / Collage`,
    screenshot: "/template-editorial-desktop.webp",
  },
  {
    id: "whimsical",
    label: t`Whimsical / Ilustrado`,
    screenshot: "/template-whimsical-desktop.webp",
  },
  {
    id: "traditional",
    label: t`Tradicional / Formal`,
    screenshot: "/template-traditional-desktop.webp",
  },
];
